const CompassIcon = () => (
  <div className="footer-icon-shell footer-compass-shell" data-testid="footer-compass-shell">
    <svg viewBox="0 0 120 120" className="footer-compass-svg" data-testid="footer-compass-icon">
      <circle cx="60" cy="60" r="46" fill="none" stroke="#1a1a1a" strokeWidth="1.6" />
      <circle cx="60" cy="60" r="4" fill="#1a1a1a" />
      <text x="60" y="18" textAnchor="middle" className="footer-compass-dir">N</text>
      <text x="60" y="110" textAnchor="middle" className="footer-compass-dir">S</text>
      <text x="104" y="65" textAnchor="middle" className="footer-compass-dir">E</text>
      <text x="16" y="65" textAnchor="middle" className="footer-compass-dir">W</text>
      <polygon points="60,20 54,60 66,60" fill="#c0392b" />
      <polygon points="60,100 54,60 66,60" fill="#2c3e50" />
    </svg>
  </div>
);

const BalloonIcon = () => (
  <div className="footer-icon-shell footer-balloon-shell" data-testid="footer-balloon-shell">
    <svg viewBox="0 0 80 130" className="footer-balloon-svg" data-testid="footer-balloon">
      <g className="footer-balloon-envelope">
        <ellipse cx="40" cy="35" rx="28" ry="35" fill="#c0392b" />
        <ellipse cx="40" cy="35" rx="28" ry="35" fill="url(#footerBalloonShade)" />
        <path d="M28,62 Q34,72 40,75 Q46,72 52,62" fill="#c0392b" />
      </g>
      <line x1="30" y1="68" x2="33" y2="100" stroke="#2c3e50" strokeWidth="0.8" />
      <line x1="50" y1="68" x2="47" y2="100" stroke="#2c3e50" strokeWidth="0.8" />
      <line x1="40" y1="75" x2="40" y2="100" stroke="#2c3e50" strokeWidth="0.8" />
      <rect x="31" y="100" width="18" height="12" rx="2" fill="#8B6914" stroke="#5C4410" strokeWidth="0.5" />
      <g className="footer-sandbag footer-sandbag-left">
        <line x1="34" y1="112" x2="31" y2="119" stroke="#5C4410" strokeWidth="0.6" />
        <ellipse cx="31" cy="123" rx="3.8" ry="5.2" fill="#8B6914" stroke="#5C4410" strokeWidth="0.5" />
      </g>
      <g className="footer-sandbag footer-sandbag-right">
        <line x1="46" y1="112" x2="49" y2="119" stroke="#5C4410" strokeWidth="0.6" />
        <ellipse cx="49" cy="123" rx="3.8" ry="5.2" fill="#8B6914" stroke="#5C4410" strokeWidth="0.5" />
      </g>
      <defs>
        <linearGradient id="footerBalloonShade" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="rgba(0,0,0,0.15)" />
          <stop offset="40%" stopColor="rgba(255,255,255,0.1)" />
          <stop offset="100%" stopColor="rgba(0,0,0,0.2)" />
        </linearGradient>
      </defs>
    </svg>
  </div>
);

const SwirlIcon = () => (
  <div className="footer-icon-shell footer-swirl-shell" data-testid="footer-swirl-shell">
    <svg viewBox="0 0 100 100" className="footer-swirl-svg" data-testid="footer-swirl-icon">
      <path
        d="M50,12 C72,12 88,28 88,50 C88,72 72,88 50,88 C33,88 20,78 20,60 C20,44 33,34 48,34 C59,34 66,41 66,50 C66,57 60,62 53,62"
        fill="none"
        stroke="#0055cc"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

const Footer = () => (
  <footer className="footer" data-testid="footer">
    <div className="footer-content">
      <p className="footer-true-discovery" data-testid="footer-true-discovery">True Discovery</p>
      <div className="footer-icon-row" data-testid="footer-icon-row">
        <CompassIcon />
        <SwirlIcon />
        <BalloonIcon />
      </div>
      <div className="footer-contact" data-testid="footer-contact-block">
        <p className="contact-label" data-testid="footer-contact-label">Contact</p>
        <a href="mailto:info@veruminventa.com" data-testid="email-link">info@veruminventa.com</a>
      </div>
      <p className="copyright" data-testid="footer-copyright">Verum Inventa is a registered trademark 2026</p>
    </div>
  </footer>
);

export default Footer;
